import type { CostCenter, ModelTypeEnum } from "~/application/types";

export enum FindCostCenterState {
  ALL = "all",
  ACTIVE = "active",
  INACTIVE = "inactive",
}
export interface IFindCostCenterParams {
  customerId: string;
  name?: string;
  page?: number;
  state?: FindCostCenterState;
  phase?: string | null;
  hasIssuedOrder?: boolean;
  filterByCostCenter?: boolean | null;
  withApprovalModels?: boolean;
  modelTypes?: ModelTypeEnum[];
  headquartersOnly?: boolean;
  branchIds?: string[];
  isActive?: boolean;
  customerEmployeeIds?: string[];
  context?: string;
}
export interface IFindCostCenterWithoutApprovalModelLinkParams {
  name?: string;
  customerId: string;
  approvalModelId?: string;
  modelTypes?: ModelTypeEnum[];
  branchIds?: string[];
  headquartersOnly?: boolean;
  isActive?: boolean;
}
export interface ICostCenterService {
  findById(id: string): Promise<CostCenter>;
  find(data: IFindCostCenterParams): Promise<CostCenter[]>;
  findWithoutApprovalModelLink(
    _: IFindCostCenterWithoutApprovalModelLinkParams,
  ): Promise<CostCenter[]>;
  create(data: Omit<CostCenter, "uuid">): Promise<CostCenter>;
  updateById(data: CostCenter): Promise<CostCenter>;
  toggleActive(data: CostCenter): Promise<void>;
  deleteById(data: CostCenter): Promise<void>;
}
